import React from "react"
import _ from "lodash"
import {
    ArchitectureOutlined,
    ConnectWithoutContactOutlined
} from "@mui/icons-material"
import {
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material"
import {makeStyles} from "@mui/styles"

export default function StudentExams(props) {
    const studentInfo = _.get(props, "studentInfo", {})
    let examAdmits = _.get(studentInfo, "meta_data.examAdmits", [])
    const classes = useStyles()
    return (
        <div className={classes.root}>
            {
                !(Array.isArray(examAdmits) && examAdmits.length > 0) && (
                    <Typography className={classes.empty}>No exam reports yet.</Typography>
                )
            }
            {
                Array.isArray(examAdmits) && examAdmits.length > 0 &&
                examAdmits.map((item, index) => {
                    return (
                        <div key={index + item.examName} className={classes.itemWrapper} >
                            <ArchitectureOutlined className={classes.icon} />
                            <Typography classes={{
                                root:classes.itemText
                            }}>{item.examName}</Typography>
                            <div style={{flex:1}} />
                            <Tooltip title={"View Test Report"} arrow placement="bottom">
                                <IconButton size="small">
                                    <ConnectWithoutContactOutlined className={classes.icon} />
                                </IconButton>
                            </Tooltip>
                        </div>
                    )
                })
            }
        </div>
    )
}

const useStyles = makeStyles({
    root: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
    },
    itemWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        minHeight: "40px",
        padding: "0 6px 0 12px",
        borderRadius: "10px",
        backgroundColor: "#f8fafc",
        border: "1px solid #f1f5f9",
    },
    itemText: {
        fontFamily: "inherit",
        fontWeight: 600,
        fontSize: "13px",
        color: "var(--text-primary)",
        marginLeft: "10px",
    },
    icon: {
        color: "var(--accent, var(--color-primary))",
        fontSize: "18px",
    },
    empty: {
        fontSize: "13px",
        color: "var(--text-light)",
        padding: "10px 12px",
        borderRadius: "10px",
        backgroundColor: "#f8fafc",
    },
})
